export const MODEL_INTIAL_OBJECT = {
  display_name: "",
  model: "",
  name_of_model: "",
  description: "",
};

export const PERSONA_INITIAL_OBJECT = {
  age_max: 0,
  age_min: 0,
  gender: "",
  id: "",
  name: "",
  pain_points: "",
};

export const samplePromptsConfig = [
  {
    title: "Draft Reply",
    desc: "Draft a clear and professional reply confirming receipt of this message and outlining the next steps.",
    icon: "/assets/icon-draft-reply.png",
    action: "draft_reply",
  },
  {
    title: "Translation",
    desc: "Translate this email into your language of choice while keeping the same professional tone and formatting.",
    icon: "/assets/icon-translate.png",
    action: "translate",
  },
  {
    title: "Summarisation",
    desc: "Summarise this email thread into key points and highlight any actions or decisions.",
    icon: "/assets/icon-summary.png",
    action: "summarize",
  },
];

export const composeSamplePRomptsConfig = [
  {
    title: "Write a Mail",
    desc: "Ask Elysia to compose a message for you",
    icon: "/assets/icon-compose.png",
    action: "compose_draft",
  },
];

export const ELYSIA_INTERNAL_ERROR_MESSAGE =
  "Sorry Elysia encountered an internal error. Please resubmit your prompt. If error persists please email elysia-feedback@informa.com with the details.";
